import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const pageContextInitPayloadSchema = z
    .object({
        type: z.literal('page_context_init').optional(),
        context: z.record(z.string(), z.json()),
    })
    .strip();

export const pageContextInitDefinitions = {
    page_context_init: defineInvisible('page_context_init', {
        disposition: 'invisible',
        schema: pageContextInitPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const pageContextInitContractFixtures = {
    valid: {
        type: 'page_context_init',
        context: {
            route: '/agent/runs/example',
            selected_shift_ids: ['00000000-0000-4000-8000-000000000001'],
        },
    },
    malformed: {
        type: 'page_context_init',
        context: ['not', 'an', 'object'],
    },
} as const;
